import { render, staticRenderFns } from "./ReportScoringWeeks.vue?vue&type=template&id=8f1b00d4&"
import script from "./ReportScoringWeeks.vue?vue&type=script&lang=js&"
export * from "./ReportScoringWeeks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports